import { PriceObjectDtoSchema } from "@/modules/common/priceObject/gateway/priceObjectApiDto"
import { HUImageDtoSchema } from "@/modules/dtos/imageDto"
import { z } from "zod"

export const BoxShopItemCategory = {
  SNACK: "SNACK",
  BEVERAGE: "BEVERAGE",
  CLOTHING: "CLOTHING",
  ACCESSORY: "ACCESSORY",
} as const

export type BoxShopItemCategory = (typeof BoxShopItemCategory)[keyof typeof BoxShopItemCategory]

export const BoxShopItemInputDtoSchema = z
  .object({
    title: z.string().min(1).max(64),
    brand: z.string().max(64).nullable(),
    description: z.string().min(1),
    category: z.enum(BoxShopItemCategory),
    price: z.number().min(0),
    stock: z.int32().min(0),
    imageKey: z.string().min(1).nullable(),
  })
  .meta({ id: "BoxShopItemInputDtoSchema" })

export const BoxShopItemDtoSchema = z
  .object({
    id: z.string(),
    title: z.string().min(1).max(64),
    brand: z.string().min(1).max(64).nullable(),
    description: z.string(),
    category: z.enum(BoxShopItemCategory),
    price: PriceObjectDtoSchema,
    taxAmount: z.number().nullable(),
    stock: z.int32(),
    image: HUImageDtoSchema.nullable(),
  })
  .meta({ id: "BoxShopItemDtoSchema" })

export type BoxShopItemInputDto = z.infer<typeof BoxShopItemInputDtoSchema>
export type BoxShopItemDto = z.infer<typeof BoxShopItemDtoSchema>
